<script>

    import { createEventDispatcher } from 'svelte'

    import Button from './button.svelte'

    const dispatch = createEventDispatcher()

    export let loading = false
    export let color = 'primary'
    export let textSave = 'Guardar'
    export let textCancel = 'Cancelar'
    export let iconSave = 'save'
    export let iconCancel = 'ban'
    export let hideCancel = false

</script>

<form on:submit|preventDefault>

    <slot></slot>

    <hr>
    <div class="items end">
        {#if !hideCancel}
            <div class="space right">
                <Button text={textCancel} icon={iconCancel} on:click={() => dispatch('canceled')} />
            </div>
        {/if}
        <Button type="submit" text={textSave} icon={iconSave} fullwidth={hideCancel} {color} {loading} />
    </div>
</form>